import React, { useEffect, useState } from "react";
import { Loader2, ImageOff } from "lucide-react";
import API from "../../lib/api";

const PhotoThumb = ({ interventionId, photo, className = "", onClick }) => {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    let blobUrl;
    API.get(`/interventions/${interventionId}/photos/${photo.id}`, { responseType: "blob" })
      .then((r) => {
        if (active) {
          blobUrl = URL.createObjectURL(r.data);
          setUrl(blobUrl);
        }
      })
      .catch(() => active && setError(true));
    return () => {
      active = false;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [interventionId, photo.id]);

  if (error) {
    return (
      <div className={`flex items-center justify-center bg-slate-100 text-slate-400 ${className}`}>
        <ImageOff className="w-5 h-5" />
      </div>
    );
  }
  if (!url) {
    return (
      <div className={`flex items-center justify-center bg-slate-100 ${className}`}>
        <Loader2 className="w-5 h-5 animate-spin text-slate-400" />
      </div>
    );
  }
  return (
    <img
      src={url}
      alt={photo.category}
      className={`object-cover ${className}`}
      onClick={onClick}
      data-testid={`photo-thumb-${photo.id}`}
    />
  );
};

export default PhotoThumb;
